import type { Feature } from '@op/services'
import {
	activeUserHasFeatureCapableDevice$,
	FeatureRequirements,
	fetchAccessState,
	fetchBlockStatuses,
	fetchDevices,
	fetchUsers,
	hasChildren$,
	hasMaxDevices$,
	hasVewCompatibleSKU$,
	isMinPremAccess$,
	unwrapThunks,
} from '@op/services'
import { setGuardModalType } from '../reducers/app-misc.slice'
import type { OPThunk, OPThunkP } from '../types'

export const canActivateAddChildAction = (): OPThunkP<boolean> => async (dispatch, getState) => {
	// We need to make sure we have initialized devices
	await Promise.all(
		unwrapThunks([
			dispatch(fetchAccessState()),
			dispatch(fetchBlockStatuses()),
			dispatch(fetchDevices()),
			dispatch(fetchUsers()),
		]),
	)

	const state = getState()

	// If we have children and have max devices
	if (hasChildren$(state) && hasMaxDevices$(state)) {
		dispatch(setGuardModalType(isMinPremAccess$(state) ? 'max_devices_contact' : 'max_devices'))

		return false
	}

	return true
}

export const canActivateFeature =
	(feature: Exclude<Feature, 'GEO'>): OPThunk<boolean> =>
	(dispatch, getState) => {
		const state = getState()

		const hasSKUAccess = feature == 'VEW' ? hasVewCompatibleSKU$(state) : isMinPremAccess$(state)

		if (!hasSKUAccess || !activeUserHasFeatureCapableDevice$(state, FeatureRequirements[feature])) {
			dispatch(setGuardModalType(feature))
			return false
		}

		return true
	}
